import React from 'react';

/**
 * Content-only component: OverlayTrigger mounts it inside a Base UI popup.
 * Mirrors react-bootstrap's <Popover title>children</Popover>.
 *
 * @param {object} props
 * @param {React.ReactNode} [props.title] Optional heading above the content.
 */
const Popover = ({ title, className, children, ...rest }) => (
  <div className={['ui-popover', className].filter(Boolean).join(' ')} {...rest}>
    {title && <h3 className="ui-popover__title">{title}</h3>}
    <div className="ui-popover__content">{children}</div>
  </div>
);

export default Popover;
